import { Linkedin, Facebook, Youtube, Twitter, Github, Instagram, Globe } from "lucide-react";

function gsearch(q) {
  return `https://www.google.com/search?q=${encodeURIComponent(q)}`;
}

function buildQuery(lead) {
  const name = `${lead.first_name || ""} ${lead.last_name || ""}`.trim();
  const company = lead.company_name || "";
  return [name, company].filter(Boolean).join(" ").trim();
}

// Reddit logo isn't in lucide-react — render a tiny inline SVG instead.
function RedditIcon({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.687a.213.213 0 0 1 0-.306.22.22 0 0 1 .305 0c.379.377 1.005.561 1.926.561l.008.002.008-.002c.92 0 1.546-.184 1.926-.562a.215.215 0 0 1 .305.001zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.923.412-.923.919 0 .506.414.918.923.918.508.001.922-.411.922-.918zm4.249-.918c-.508 0-.922.412-.922.918 0 .506.414.918.922.918s.922-.412.922-.918a.919.919 0 0 0-.922-.918zm6.953-1.013c0 6.071-4.957 11-11.041 11-6.083 0-11.041-4.929-11.041-11s4.958-11 11.041-11c6.084 0 11.041 4.929 11.041 11zm-5.467-.118c0-.86-.703-1.559-1.567-1.559a1.56 1.56 0 0 0-1.13.487c-1.107-.799-2.633-1.317-4.317-1.378l.733-3.453 2.398.51a1.122 1.122 0 1 0 2.222-.222c0-.617-.504-1.118-1.124-1.118-.44 0-.818.253-1.001.62l-2.679-.572a.215.215 0 0 0-.256.165l-.817 3.847c-1.711.047-3.261.567-4.388 1.376a1.56 1.56 0 0 0-1.128-.485 1.564 1.564 0 0 0-1.567 1.559c0 .609.352 1.143.871 1.394a3.058 3.058 0 0 0-.04.499c0 2.524 2.844 4.582 6.342 4.582 3.497 0 6.342-2.057 6.342-4.582 0-.181-.014-.355-.04-.527.5-.258.844-.785.844-1.387z"/>
    </svg>
  );
}

const PLATFORMS = [
  { key: "linkedin", label: "LinkedIn", Icon: Linkedin, site: "linkedin.com" },
  { key: "twitter",  label: "X / Twitter", Icon: Twitter, site: "twitter.com OR x.com" },
  { key: "facebook", label: "Facebook", Icon: Facebook, site: "facebook.com" },
  { key: "youtube",  label: "YouTube", Icon: Youtube, site: "youtube.com" },
  { key: "reddit",   label: "Reddit", Icon: RedditIcon, site: "reddit.com" },
  { key: "github",   label: "GitHub", Icon: Github, site: "github.com" },
  { key: "instagram",label: "Instagram", Icon: Instagram, site: "instagram.com" },
];

export default function SocialLinks({ lead, size = 13 }) {
  const q = buildQuery(lead);
  if (!q) return <span className="text-xs text-muted-foreground">—</span>;

  return (
    <div className="flex items-center gap-2" data-testid={`social-links-${lead.id}`}>
      {/* If we already have a direct LinkedIn URL, link to it; otherwise search */}
      {lead.linkedin_prospect_link ? (
        <a
          href={lead.linkedin_prospect_link}
          target="_blank" rel="noopener noreferrer"
          title="Open LinkedIn profile (saved on lead)"
          className="text-[#0a66c2] hover:opacity-70"
          data-testid={`social-linkedin-direct-${lead.id}`}
        >
          <Linkedin size={size} />
        </a>
      ) : (
        <a
          href={gsearch(`${q} site:linkedin.com/in`)}
          target="_blank" rel="noopener noreferrer"
          title="Find on LinkedIn (Google search)"
          className="text-[#0a66c2] hover:opacity-70"
          data-testid={`social-linkedin-${lead.id}`}
        >
          <Linkedin size={size} />
        </a>
      )}
      {PLATFORMS.filter((p) => p.key !== "linkedin").map(({ key, label, Icon, site }) => (
        <a
          key={key}
          href={gsearch(`${q} site:${site}`)}
          target="_blank" rel="noopener noreferrer"
          title={`Find on ${label} (Google search)`}
          className="text-muted-foreground hover:text-foreground"
          data-testid={`social-${key}-${lead.id}`}
        >
          <Icon size={size} />
        </a>
      ))}
      {lead.website && (
        <a
          href={lead.website.startsWith("http") ? lead.website : `https://${lead.website}`}
          target="_blank" rel="noopener noreferrer"
          title="Company website"
          className="text-muted-foreground hover:text-foreground"
          data-testid={`social-website-${lead.id}`}
        >
          <Globe size={size} />
        </a>
      )}
    </div>
  );
}
